var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import getRoleProperty from '../getRoleProperty';

var ContactRoleDriverCtrl = function () {
        function ContactRoleDriverCtrl($filter) {
                _classCallCheck(this, ContactRoleDriverCtrl);

                this._translator = function (name) {
                        return $filter('translate')('gateway.contacts.components.ContactDetails.Roles.Driver.' + name);
                };
        }

        _createClass(ContactRoleDriverCtrl, [{
                key: '$onInit',
                value: function $onInit() {
                        var _getRoleProperty = getRoleProperty(this.roleType, this.roleModel, 'driver', 'policyDriver'),
                            fieldValueGetter = _getRoleProperty.fieldValueGetter;

                        var accidents = fieldValueGetter('accidents', 'policyLevelNumberOfAccidents');
                        if (accidents) this.accidents = accidents.name;

                        var violations = fieldValueGetter('violations', 'policyLevelNumberOfViolations');
                        if (violations) this.violations = violations.name;

                        if (this.roleType === 'account') {
                                this.accidentsLabel = this._translator('Account.Accidents');
                                this.violationsLabel = this._translator('Account.Violations');
                        } else {
                                this.accidentsLabel = this._translator('Policy.Accidents');
                                this.violationsLabel = this._translator('Policy.Violations');
                        }

                        this.yearLicensed = fieldValueGetter('yearLicensed');
                        this.licenseNumber = fieldValueGetter(undefined, 'licenseNumber');

                        var licenseState = fieldValueGetter(undefined, 'licenseState');
                        if (licenseState) this.licenseState = licenseState.name;

                        this.dateCompletedTrainingClass = fieldValueGetter('dateCompletedTrainingClass');

                        var trainingClassType = fieldValueGetter('trainingClassType');
                        if (trainingClassType) this.trainingClassType = trainingClassType.name;

                        var yes = this._translator('Yes');
                        var no = this._translator('No');

                        var goodStudent = fieldValueGetter('goodStudent');
                        if (goodStudent !== undefined) this.goodStudent = goodStudent ? yes : no;

                        var qualifiesForGoodDriverDiscount = fieldValueGetter('goodDriverDiscount');
                        if (qualifiesForGoodDriverDiscount !== undefined) {
                                this.qualifiesForGoodDriverDiscount = qualifiesForGoodDriverDiscount ? yes : no;
                        }
                        var applyGoodDriverDiscount = fieldValueGetter(undefined, 'applicableGoodDriverDiscount');
                        if (applyGoodDriverDiscount !== undefined) {
                                this.applyGoodDriverDiscount = applyGoodDriverDiscount ? yes : no;
                        }

                        var excluded = fieldValueGetter(undefined, 'excluded');
                        if (excluded !== undefined) this.excluded = excluded ? yes : no;
                }
        }]);

        return ContactRoleDriverCtrl;
}();

ContactRoleDriverCtrl.$inject = ['$filter'];
export default ContactRoleDriverCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/components/roles/ContactRoleDriver/ContactRoleDriverCtrl.js
// module id = 1644
// module chunks = 0